import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';

import {
  usePropsContext,
  useUiResourceContext,
} from 'apps/website/coaching/scheduling_widget/contexts';

import useSchedulingWidgetConfig from 'apps/website/coaching/scheduling_widget/hooks/useSchedulingWidgetConfigQuery';
import reactElementFromHtmlElement from 'apps/website/coaching/scheduling_widget/utils/reactElementFromHtmlElement';
import launchPopupCheckout from 'apps/website/coaching/scheduling_widget/utils/launchPopupCheckout';

const TriggerElement = () => {
  const { trigger, triggerMountNode, coachingProgramId, offerToken, externalReferenceInitiator } =
    usePropsContext();
  const { timeslotPickerOpen, checkoutPending, checkoutCancelled, setTimeslotPickerOpen } =
    useUiResourceContext();
  const { data: config } = useSchedulingWidgetConfig();
  const { coachingProgramUsesKajabiCalendar } = config || {};
  // button is disabled when the modal is open
  const isDisabled = timeslotPickerOpen || checkoutPending || checkoutCancelled;

  const openPopupCheckoutOnClick = useMemo(
    () => !coachingProgramUsesKajabiCalendar && coachingProgramId && offerToken,
    [coachingProgramUsesKajabiCalendar, coachingProgramId, offerToken],
  );

  // If the provided coaching program does not use Kajabi Calendar, we'll instantly
  // launch the popup checkout modal when the trigger is clicked
  const handleClick = () => {
    if (isDisabled) return;
    if (openPopupCheckoutOnClick) {
      launchPopupCheckout({
        externalReferenceId: coachingProgramId!,
        externalReferenceInitiator: externalReferenceInitiator!,
        offerToken: offerToken!,
      });
    } else {
      setTimeslotPickerOpen(true);
    }
  };

  if (!(trigger instanceof HTMLElement)) return null;
  if (!(triggerMountNode instanceof HTMLElement)) return null;

  return ReactDOM.createPortal(
    React.cloneElement(reactElementFromHtmlElement(trigger), {
      onClick: handleClick,
      disabled: isDisabled,
    }),
    triggerMountNode,
  );
};

export default TriggerElement;
